"use client";
import React from "react";
import { useState } from "react";
import Icon from "../icons/Icons";
import { FooterRedirectLinkSection } from "@/type/commonTypes";
import { BLOG_ROOT, ROOT_URL } from "@/utils/gloableVariables";

export default function FooterSiteLinks({ linksData }: { linksData: FooterRedirectLinkSection[] }) {
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);

  return (
    <div className="w-full grid grid-cols-1 xs:grid-cols-3 gap-x-10 xs:gap-y-12">
      {linksData.map((item) => {
        const isOpen = openAccordion === item.title;

        return (
          <section key={item.title} className="border-y border-white/10 xs:border-none">
            <button
              type="button"
              onClick={() => setOpenAccordion((prev) => (prev === item.title ? null : item.title))}
              className="w-full flex items-center justify-between gap-4 py-4 xs:py-0 text-left sm:text-center 2lg:text-left sm:mb-3 xs:pointer-events-none"
            >
              <div className="text-white text-sm sm:text-base font-bold uppercase">{item.title}</div>

              <Icon.dropdownDownArrow
                className={`w-4 h-4 text-white transition-transform duration-300 xs:hidden ${
                  isOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            <div
              className={`grid transition-all duration-300 ease-in-out overflow-hidden xs:overflow-visible ${
                isOpen ? "grid-rows-[1fr] pb-4" : "grid-rows-[0fr]"
              } xs:grid-rows-[1fr] xs:pb-0`}
            >
              <div className="overflow-hidden">
                <ul className="space-y-2 sm:space-y-3">
                  {item.links.map((subItem) => {
                    const linkHref =
                      item.title.toLowerCase() == "blogs"
                        ? `${BLOG_ROOT}${subItem.href}`
                        : `${ROOT_URL}${subItem.href}`;
                    return (
                      <li key={subItem.name}>
                        <a
                          href={linkHref}
                          className="text-white/75 text-sm sm:text-base transition hover:text-[#90C63A]"
                        >
                          {subItem.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </section>
        );
      })}
    </div>
  );
}
